<template>
  <m-demo-box :demo-option="demoOption" :hasSaveQuickPick="this.type !== 'normal'">
    <b-modal ref="askDelete" @ok="deleteQuick" :hide-header="true" :lazy="true">
      Are you Sure to delete this quick pick?<br>
      {{quickPick.QpName}}
    </b-modal>

    <b-modal ref="seeQuickPick" title="My Quickpick Information" :ok-only="true" :lazy="true" @hidden="clear">
      <p>Quickpick Name: {{quickPick.Name}}</p>
      <p>Quickpick Desc: {{quickPick.Description}}</p>
      <div class="card card-quick-pick" v-if="quickPick.Categories">
        <div v-for="category in quickPick.Categories">
          <div v-for="item in category.Items">
            <h5>{{item.ItemDesc}}</h5>
            <p class="item-value" v-for="val in item.Values">
              {{val.Name}}
            </p>
          </div>
        </div>
      </div>
    </b-modal>
    <b-row class="demo-box" :align-h="mobileCSS">
      <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
        <m-demo-all-check />
      </b-col>
    </b-row>
    <b-row class="demo-box" :align-h="mobileCSS">
      <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
        <div class="m-disabled-box"  v-show="isAllHoseholds"></div>
        <div class="card  card-quick-pick">
          <p v-if="quickPicks.length === 0 && init">No QuickPicks have been created</p>
          <m-loader :show="!init"/>
          <div v-for="item in quickPicks" class="quick-item">
            <span>{{item.QpName}}</span>
            <span>
                <span class="quick-item-btn">
                  <span v-show="item.selected"
                        @click="removeQuick(item)"
                        class="quick-item-icon light"
                        data-test="demo-quickPick-remove">
                    <icon name="check-circle"></icon>
                  </span>
                  <span v-show="!item.selected"
                        @click="addQuick(item)"
                        class="quick-item-icon"
                        data-test="demo-quickPick-add">
                    <icon name="plus"></icon>
                  </span>
                </span>
                <span v-show="type === 'normal'"
                      @click="seeDetail(item)"
                      data-test="demo-quickPick-detail"
                      class="quick-item-icon">
                  <icon name="eye"></icon>
                </span>
                <span v-show="type === 'normal'"
                      @click="askDeleteQuick(item)"
                      data-test="demo-quickPick-delete"
                      class="quick-item-icon demo-quickPick-delete">
                  <icon name="times-circle"></icon>
                </span>
              </span>
          </div>
        </div>
      </b-col>
    </b-row>
  </m-demo-box>
</template>

<script>
  import MDemoBox from '@/components/demo/MDemoBox'
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'

  export default {
    components: {
      MDemoBox,
      MDemoAllCheck
    },
    data () {
      return {
        quickPick: {},
        init: false,
        theQuickPicks: []
      }
    },
    computed: {
      quickPicks () {
        // let quickPicks = this.$store.state.demo.quickPicks
        if (this.theQuickPicks.length === 0 && !this.init) {
          this.getQuickPick()
          return []
        }
        if (this.$store.state.demo.saveNewQuickPick) {
          this.getQuickPick()
          return []
        }
        let quickPicks = this.theQuickPicks
        for (let i = 0; i < quickPicks.length; i++) {
          if (this.type !== 'normal') {
            quickPicks[i].QpName = quickPicks[i].Name
            quickPicks[i].QpDesc = quickPicks[i].Name
          }

          let hasSelected = false
          for (let selected of this.selectedQuickPicks) {
            if (quickPicks[i].QpName === selected.AttributeValueName) {
              hasSelected = true
            }
          }
          quickPicks[i].selected = hasSelected
        }
        return quickPicks
      },
      columnQuickPicks () {
        if (this.type === 'normal') {
          return this.$store.getters['order/demoColumnItem']('Quick Pick', 2)
        } else {
          return this.$store.getters['order/demoColumnItem']('Business QuickPicks', 5)
        }
      },
      selectedQuickPicks () {
        if (this.columnQuickPicks && this.columnQuickPicks.Values) {
          return this.columnQuickPicks.Values
        } else {
          return []
        }
      },
      listType () {
        return this.$store.state.order.ListType
      },
      type () {
        if (this.$route.name === 'demo-businessQuickPicks') {
          return 'business'
        } else {
          return 'normal'
        }
      },
      demoOption () {
        if (this.type === 'business') {
          return 'businessQuickPicks'
        } else {
          return 'quickPicks'
        }
      },
      isAllHoseholds () {
        return this.$store.getters['order/isAllHoseholds']
      },
      mobileCSS () {
        return this.$store.state.config.isMobile?"center":"start"
      }
    },
    watch: {
      '$route.params.listType' () {
        this.getQuickPick()
      }
    },
    created () {
    },
    methods: {
      addQuick (item) {
        console.log(item)
        this.$store.commit('order/saveDemoType', 1)

        let quickPick = {
          AttributeName: 'Quick Pick',
          DemoCategoryType: 2,
          AttributeValue: item.QpId,
          AttributeValueName: item.QpName,
          ColumnName: 'Quick Pick',
          SortSeq: 0
        }

        if (item.QpType === 1) {
          quickPick.AttributeName = 'Site Quick Pick'
          quickPick.ColumnName = 'Site Quick Pick'
          quickPick.DemoCategoryType = 7
        }

        if (this.type === 'business') {
          quickPick.AttributeValue = item.QpName
          quickPick.AttributeName = 'Business QuickPicks'
          quickPick.ColumnName = 'Business QuickPicks'
          quickPick.DemoCategoryType = 5
        } else {
          this.clearQuick()
        }
        console.log(item,quickPick)
        this.$store.dispatch('order/addDemoByItem', quickPick)
      },
      askDeleteQuick (item) {
        this.quickPick = item
        this.$refs.askDelete.show()
      },
      deleteQuick () {
        this.$http.post('PlaceOrder.aspx/RemoveQuickPick', {
          id: this.quickPick.QpId
        }).then(resp => {
          this.removeQuick(this.quickPick)
          for (let i = 0; i <= this.theQuickPicks.length; i++) {
            if (this.theQuickPicks[i].QpId === this.quickPick.QpId) {
              this.theQuickPicks.splice(i, 1)
              return true
            }
          }
        })
      },
      removeQuick (item) {
        if (this.type === 'normal') {
          item.columnName = 'Quick Pick'
          item.type = 'column'
          item.demoCategoryType = 2
        } else {
          item.columnName = 'Business QuickPicks'
          item.demoCategoryType = 5
          item.name = ''
          item.attributeValue = item.QpName
          item.value = 'value'
          item.name = item.QpName
        }
        this.$store.dispatch('order/deleteDemo', item)
      },
      seeDetail (item) {
        this.$http.post('PlaceOrder.aspx/GetQuickPickup', {
          id: item.QpId,
          qpType: item.QpType
        }).then(resp => {
          this.quickPick = resp.body.d.DataSource
          this.$refs.seeQuickPick.show()
        })
      },
      clearQuick () {
        this.$store.commit('order/deleteDemoColumnName', 'Quick Pick')
        this.$store.commit('order/deleteDemoColumnName', 'Site Quick Pick')
      },
      getQuickPick () {
        this.theQuickPicks = []
        this.init = false
        let url = 'PlaceOrder.aspx/GetQuickPickups'
        if (this.type === 'business') {
          url = 'PlaceOrder.aspx/GetBusinessQuickpicks'
        }
        this.$http.post(url, {
          listType: this.listType
        }).then(resp => {
          // this.$store.commit('demo/saveQuickPicks', resp.body.d.DataSource)
          this.theQuickPicks = resp.body.d.DataSource
          this.init = true
          this.$store.commit('demo/saveKey', ['saveNewQuickPick', false])
        }, resp => {
          this.init = true
        })
      },
      clear () {
        this.quickPick = {}
      }
    }
  }
</script>

<style scoped lang="scss">
.quick-item {
  width: calc(60% - 16px);
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $color-border;
  padding-bottom: 32px;
  padding-top: 4px;
  padding-left: 8px;
}
/*TODO@Pony need update color*/
.item-value {
  margin-left: 8px;
}

.card-quick-pick {
  position: relative;
  padding: 8px;
  height: 500px;
  overflow-y: auto;
  border: 1px solid $color-border !important;
  border-radius: 4px;
}
.title {
  margin-top: 8px
}


</style>



// WEBPACK FOOTER //
// src/pages/order/DemoQuickPick.vue